const server = {
	//	 url: "http://localhost:8000/",
	url: "https://rocky-savannah-17725.herokuapp.com/",
	counterUrl: "counter",
	checkDateUrl: "check_date",
	testimonialsUrl: "testemonials",
	calculateUrl: "calc",
	sumUrl: "sum",
	acceptUrl: "accept",
	faq: "faq",

	get URL() {
		return this.url;
	},
	get counter() {
		return this.url + this.counterUrl;
	},
	get checkDate() {
		return this.url + this.checkDateUrl;
	},
	get testimonials() {
		return this.url + this.testimonialsUrl;
	},
	get calculate() {
		return this.url + this.calculateUrl;
	},
	get sum() {
		return this.url + this.sumUrl;
	},
	get accept() {
		return this.url + this.acceptUrl;
	},
	get getFaq() {
		return this.url + this.faq;
	}
};

export default server;
